// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getStorage } from "firebase/storage";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCAisjHTOn21gbpbt5-hvFPPvJHKFqrYO0",
  authDomain: "portfolio-49d5b.firebaseapp.com",
  projectId: "portfolio-49d5b",
  storageBucket: "portfolio-49d5b.appspot.com",
  messagingSenderId: "599880546312",
  appId: "1:599880546312:web:37173c8509b167bc11f9bd",
  measurementId: "G-W2E768HRE8",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const storage = getStorage(app);
